var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import GlobalVue from "../globalVue";
import moduleDic from "../helper/moduleDic";
import { mapActions, mapGetters } from "vuex";
import CommonService from "../api/CommonService";
import { CachePocily } from "../common/Cache";
import { ECache } from '../enum/ECache';
import CACHE_KEY from "../constant/cacheKey";
import EMenuTab from "../enum/EMenuTab";
import { noAuthList } from "../constant/authCode";
import GenerateInvoice from "@/page/accountcheck/components/GenerateInvoice";
var MainMenu = (function (_super) {
    __extends(MainMenu, _super);
    function MainMenu() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.subOpens = [];
        _this.mainMenu = [];
        _this.prefix = "MENU_";
        _this.defaultActive = _this.prefix + "1";
        _this.cache = CachePocily.getInstance(ECache.LocCache);
        _this.loginForm = {};
        _this.times = 0;
        return _this;
    }
    MainMenu.prototype.created = function () {
        this.commonService = CommonService.getInstance();
        this.getMenu();
        var infor = this.cache.getData(CACHE_KEY.LOGIN);
        if (infor) {
            if (infor.userInfo) {
                this.loginForm = JSON.parse(infor.userInfo);
            }
        }
    };
    MainMenu.prototype.mounted = function () {
        document.getElementsByClassName("menu-content")[0].style.height = document.documentElement.clientHeight + 'px';
    };
    MainMenu.prototype.getMenu = function (params) {
        var _this = this;
        if (params === void 0) { params = { noLoginTrigger: false }; }
        var noLoginTrigger = params.noLoginTrigger;
        this.commonService.getMenu().then(function (res) {
            if (res.data.success) {
                _this.mainMenu = res.data.data;
                _this.updateMenuList(_this.mainMenu);
                if (!noLoginTrigger && _this.loginForm.info_complete == 0) {
                    _this.getAuth("6001").then(function (pageAuth) {
                        if (pageAuth) {
                            _this.openPage({ power_code: "6001", power_id: 5, power_cn: '企业信息' });
                        }
                        else {
                            _this.mainMenu.length && _this.openPage({ power_code: _this.mainMenu[0].power_code, power_id: _this.mainMenu[0].power_id });
                        }
                    });
                }
                else {
                    _this.mainMenu.length && _this.openPage({ power_code: _this.mainMenu[0].power_code, power_id: _this.mainMenu[0].power_id });
                }
            }
            else {
                _this.$message.error(res.data.msg);
            }
        }, function (err) {
            _this.$message.error(err.message || err.msg);
        }).catch(function (err) {
            _this.$message.error(err.message);
        });
    };
    MainMenu.prototype.openPage = function (menu) {
        var _this = this;
        layer.close(layer.index);
        var _a = this.serviceData, flag = _a.flag, list = _a.list;
        this.times++;
        console.log('this.times>>>', this.times);
        if (flag == 1) {
            var flag_1 = false;
            list.forEach(function (item, index) {
                if (item.power_key.indexOf(menu.power_code) != -1) {
                    _this.$emit('openServiceDialog', item);
                    flag_1 = true;
                }
            });
            if (flag_1)
                return;
        }
        this.getAuth(menu.power_code).then(function (pageAuth) {
            var isNoNeedAuth = noAuthList.indexOf(menu.power_code) != -1;
            if (isNoNeedAuth)
                pageAuth = { Name: menu.power_cn, Code: menu.power_code, Auth: {} };
            menu = !menu.power_id ? pageAuth.Response : menu;
            if (menu.power_id_parent && menu.power_id_parent !== 0) {
                _this.subOpens = [_this.prefix + menu.power_id_parent];
            }
            else {
                _this.subOpens = [];
            }
            _this.defaultActive = _this.prefix + menu.power_id;
            console.log('moduleDic>>>', moduleDic[menu.power_id], moduleDic);
            if (moduleDic[menu.power_id] === 'Invoice') {
                var instance = _this.$dialog(GenerateInvoice, {
                    from: 'menu'
                }, {
                    title: '发票管理',
                    width: 400,
                    height: 300,
                    zIndex: 3000
                });
                return;
            }
            if (moduleDic[menu.power_id]) {
                var title = EMenuTab[menu.power_id] ? EMenuTab[menu.power_id] : menu.power_cn;
                console.log('getAuth>>>', menu);
                GlobalVue.$emit("addTab", {
                    component: moduleDic[menu.power_id],
                    title: title,
                    name: menu.power_id,
                    showExist: true,
                    callback: menu.cb,
                    cprops: __assign({}, menu, { Root_PageAuth: pageAuth && pageAuth.Auth, root_PageAuth$$: pageAuth && pageAuth.Auth })
                });
            }
            if (menu.power_id === 1) {
                _this.$emit('item-click', menu, true, pageAuth);
            }
            else {
                _this.$emit('item-click', menu, false, pageAuth);
            }
        });
    };
    __decorate([
        Prop({
            type: Boolean,
            required: true
        })
    ], MainMenu.prototype, "isCollapse", void 0);
    MainMenu = __decorate([
        Component({
            methods: __assign({}, mapActions(["updateMenuList", "getAuth"])),
            computed: __assign({}, mapGetters({
                serviceData: 'serviceData'
            }))
        })
    ], MainMenu);
    return MainMenu;
}(Vue));
export default MainMenu;
